import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Spin, Empty } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, CrownOutlined } from '@ant-design/icons';
import { getGoodlookeroById } from 'src/api/goodlookeros';
import styles from './ValidateGoodlookero.module.css';

interface Goodlookero {
   id: string;
   Nombre: string;
   Categoria: string;
   Ciudades: string[];
   Foto: string;
   Activo: boolean;
}

const ValidateGoodlookero = () => {
   const { idGoodlookero } = useParams<{ idGoodlookero: string }>();
   const [goodlookero, setGoodlookero] = useState<Goodlookero | null>(null);
   const [loading, setLoading] = useState(true);
   const [error, setError] = useState<string | null>(null);

   useEffect(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
   }, []);

   useEffect(() => {
      const fetchGoodlookero = async () => {
         try {
            setLoading(true);
            if (!idGoodlookero) {
               setError('ID de Goodlookero no proporcionado');
               setLoading(false);
               return;
            }

            const result: any = await getGoodlookeroById(idGoodlookero);
            
            if (result.success === 'true') {
               setGoodlookero(result);
               setError(null);
            } else {
               setError(result.errors || 'Error al obtener el goodlookero');
               setGoodlookero(null);
            }
         } catch (err: any) {
            setError(err.message || 'Error desconocido');
            setGoodlookero(null);
         } finally {
            setLoading(false);
         }
      };

      fetchGoodlookero();
   }, [idGoodlookero]);

   if (loading) {
      return (
         <div className={styles.container}>
            <Spin size="large" />
         </div>
      );
   }

   if (error || !goodlookero) {
      return (
         <div className={styles.container}>
            <Empty description={error || 'Goodlookero no encontrado'} />
         </div>
      );
   }

   const isPremium = goodlookero.Categoria?.toUpperCase() === 'PREMIUM';
   const isActive = goodlookero.Activo === true;

   return (
      <div className={styles.container}>
         <div className={`${styles.card} `}>
            {/* Foto con ícono de estado en esquina superior derecha */}
            <div className={styles.photoContainer}>
               <div className={`${styles.photoWrapper}`}>
                  <img 
                     src={goodlookero.Foto} 
                     alt={goodlookero.Nombre}
                     className={`${styles.photo} ${!isActive ? styles.photoInactivo : ''}`}
                  />
                  {!isActive && (
                     <div className={styles.blockedBadge}>
                        BLOQUEADO
                     </div>
                  )}
               </div>
            </div>

            {/* Información */}
            <div className={styles.info}>
               <div className={styles.header}>
                  <h1 className={styles.nombre}>{goodlookero.Nombre}</h1>
                  <div className={styles.categoria}>
                     {isPremium && <CrownOutlined className={styles.crownIcon} />}
                     <span>{goodlookero.Categoria}</span>
                  </div>
               </div>

      
            {/* Leyenda de garantía o advertencia */}
            <div className={`${styles.leyendaBadge} ${isActive ? styles.leyendaActiva : styles.leyendaInactiva}`}>
            {isActive ? (
                <span>Tienes garantía de calidad GoodLook con {goodlookero.Nombre.split(" ")[0]}</span>
            ) : (
                <span>Repórtalo al <a href="tel:5510790688">55 1079 0688</a></span>
            )}
            </div>


               <div className={styles.ciudades}>
                  <h2>Ciudades</h2>
                  <ul>
                     {goodlookero.Ciudades && goodlookero.Ciudades.map((ciudad: string, index: number) => (
                        <li key={index}>{ciudad}</li>
                     ))}
                  </ul>
               </div>
            </div>
         </div>
      </div>
   );
};

export default ValidateGoodlookero;
